import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex/icons';
import * as lines from '../../Helpers/LinesHelper';

const FeaturesDiv = styled.div`
  width: 100%;
  max-width: 254px;
  margin-bottom: 8px;
  margin-top: 8px;
  font-family: Helvetica;
  font-size: 14px;
    
  @media ${(props) => props.theme.breakpoints.tablet} {
    max-width: 218px;
  }

  @media ${(props) => props.theme.breakpoints.mobile} {
    max-width: 118px;
    margin: auto;
  }
`;

const FeaturesMainDiv = styled.div`
  width: 100%;
  max-width: 254px;

  margin-bottom: 8px;
  margin-top: 8px;
  font-family: Helvetica;
  font-size: 14px;
  display: flex;
    
  @media ${(props) => props.theme.breakpoints.tablet} {
    max-width: 218px;
  }

  @media ${(props) => props.theme.breakpoints.mobile} {
    max-width: 118px;
  }
`;

const FeaturesContentDiv = styled.div`
  width: 50%;
`;

const FeaturesActionDiv = styled.div`
  width: 50%;
  justify-content: flex-end;
  display: flex;
`;

const StyledLine = styled.hr`
  border-top: 1px solid #d3d3d3;
  width: 100%;
  max-width: 252px;
  margin: 0px;
    
  @media ${(props) => props.theme.breakpoints.tablet} {
    max-width: 218px;
  }

  @media ${(props) => props.theme.breakpoints.mobile} {
    max-width: 118px;
    margin: auto;
  }
`;

const Circle = styled.span`
  height: 17px;
  width: 17px;
  background-color: #ee9124;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  color: #ffffff;
`;

const FeatureCounter = styled.div`
padding-top: 0.5px;
`;

const StyledIcon = styled(Icon)`
  width: 15px;
  margin: 0px 6px 0px 7px;
  color: #505da4;
`;

const FeaturesParametersWrapper = styled.div`
  padding-top: 5px;
  width: 100%;
  max-width: 256px;
  
  @media ${(props) => props.theme.breakpoints.tablet} {
    max-width: 220px;
  }
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    max-width: 140px;
  }
`;

const FeatureRow = styled.div`
  height: ${(props) => lines.getLineHeightFeaturesDesktop(props.lineLength)}px;
  box-sizing: border-box;
  background: #f5f7fd;
  width: 100%;
  margin: 0px 0px 5px 0px;
  padding: 7px 0 5px 5px;
  display: flex;
  
  @media (max-width: 1239px) { 
    height: ${(props) => lines.getLineHeight1239(props.lineLength)}px;
  }

  @media ${(props) => props.theme.breakpoints.tablet} {
    height: ${(props) => lines.getLineHeightFeaturesTablet(props.lineLength)}px;
  }

  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 5px 11px 5px 5px;
    height: ${(props) => lines.getLineHeightFeaturesMobile(props.lineLength)}px;
  }
`;

const FeatureRowContent = styled.div`
   width: 80%;
`;

const FeatureRowIcon = styled.div`
   width: 20%;
   justify-content: flex-end;
   display: flex;
`;

const FeatureWhiteRow = styled.div`
  box-sizing: border-box;
  background: #ffffff;
  height: ${(props) => lines.getLineHeightFeaturesDesktop(props.lineLength)}px;
  width: 100%;
  margin: 0px 0px 5px 0px;
  padding: 7px 0 5px 5px;

  
  @media (max-width: 1239px) { 
    height: ${(props) => lines.getLineHeight1239(props.lineLength)}px;
  }

  @media ${(props) => props.theme.breakpoints.tablet} {
    height: ${(props) => lines.getLineHeightFeaturesTablet(props.lineLength)}px;
  }

  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 5px 11px 5px 5px;
    height: ${(props) => lines.getLineHeightFeaturesMobile(props.lineLength)}px;
  }
`;

const FeatureRowLabel = styled.div`
  font-family: Helvetica;
  font-size: 14px;
  color: #333333;
`;

const FeatureWhiteRowLabel = styled.div`
  font-family: Helvetica;
  font-size: 14px;
  color: #ffffff;
`;

const StyledIconForFeature = styled(Icon)`
  width: 15px;
  height: 10px;
  margin: 0px 5px 0px 0px;
  color: #505da4;
`;
const getRotation = (isOpen) => (isOpen ? 180 : 0);

const renderEmptyRows = (features, lineLengths) => {
  const rows = [];
  for (let i = features.length; i < lineLengths.length; i++) {
    rows.push(
      <React.Fragment key={i}>
        <FeatureWhiteRow lineLength={lineLengths[i]}>
          <FeatureWhiteRowLabel />
        </FeatureWhiteRow>
      </React.Fragment>
    );
  }
  return rows;
};

const ProductFeatures = ({
  isOpen, featuresHeaderText, features, lineLengths
}) => (
  <FeaturesDiv>
    <StyledLine />
    <FeaturesMainDiv>
      <FeaturesContentDiv>
        {featuresHeaderText}
      </FeaturesContentDiv>
      <FeaturesActionDiv>
        <Circle>
          <FeatureCounter>
            {features.length}
          </FeatureCounter>
        </Circle>
        <StyledIcon icon={'ArrowDown'} rotate={getRotation(isOpen)} />
      </FeaturesActionDiv>
    </FeaturesMainDiv>
    <StyledLine />
    <FeaturesParametersWrapper>
      {features.map((feature, index) => (
        <React.Fragment key={feature.label}>
          <FeatureRow key={feature.label} lineLength={lineLengths[index]}>
            <FeatureRowContent>
              <FeatureRowLabel>{feature.label}</FeatureRowLabel>
            </FeatureRowContent>
            <FeatureRowIcon>
              <StyledIconForFeature icon={'info-icon'} />
            </FeatureRowIcon>
            <FeatureWhiteRowLabel />
          </FeatureRow>
        </React.Fragment>
      ))}

      {renderEmptyRows(features, lineLengths)}
    </FeaturesParametersWrapper>
  </FeaturesDiv>
);

ProductFeatures.propTypes = {
  features: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  isOpen: PropTypes.bool,
  featuresHeaderText: PropTypes.string.isRequired,
  lineLengths: PropTypes.arrayOf(PropTypes.number).isRequired
};

ProductFeatures.defaultProps = {
  isOpen: true
};

export default ProductFeatures;
